import { render, staticRenderFns } from "./FormAssetPublish.vue?vue&type=template&id=3aa20a90&lang=pug"
import script from "./FormAssetPublish.vue?vue&type=script&lang=js"
export * from "./FormAssetPublish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports